var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-menu',{attrs:{"offset-y":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [(!_vm.render)?_c('user-profile-info-component',{attrs:{"on":on,"attrs":attrs},model:{value:(_vm.user),callback:function ($$v) {_vm.user=$$v},expression:"user"}}):_vm._e()]}}])},[_c('v-list',[_c('user-profile-header-link'),_c('user-profile-header-system-exit-button')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }